import { ButtonHTMLAttributes } from 'react';
import { NiceButton } from '../../../../../generic/components/buttons/nice-button';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export function FormButton({ children, ...props }: Props) {
  return (
    <NiceButton theme={'dark'} {...props}>
      {children}
    </NiceButton>
  );
}
